import {
    PRESUPUESTADOR_CALCULATE_REMAINDER_SUCCESS,
  } from '../constants';
  

  export function reducer(state, action) {
      if (action.type === PRESUPUESTADOR_CALCULATE_REMAINDER_SUCCESS) {
          return {
              ...state,
              ...action.data
          }
      }
      else {
          return state
      }
  }